import { Component } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '@envs/environment';
import { Datadog } from '@core/models/datadog';
import { BydI18nService } from '@sixense/ds-lib-utils';

@Component({
  selector: 'ds-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  /**
   *
   */
  title = 'ds-web-front';

  /**
   * The application component.
   *
   * @param translationsManager Ds-lib-common translations manager,
   * injects ds-lib-common's specific translations into existing translations.
   * @param i18nService innject's the translations from libraries
   * @param overlayContainer Container inside which all overlays will render
   */
  constructor(protected i18nService: BydI18nService, public overlayContainer: OverlayContainer) {
    if (environment.datadog?.enabled) {
      datadogRum.init(new Datadog(environment.datadog));
      datadogRum.startSessionReplayRecording();
    }

    this.overlayContainer.getContainerElement().classList.add('ds-container');
  }
}
